module.exports = __webpack_public_path__ + "static/media/mastercard.6957b6f4.svg";